export interface UpdateOrderRequest {
  id: number
  status: string
  cancelReason: string
  managementFlag: string
  collectionType: string
  handlingType: string
  storeType: string
  appendixCode: string
  buyBranchCode: string
  departmentCode: string
  shelfType: string
  mark: string
  ndc: string
  book: string
  sub: string
  orderDate: string
  tempAcceptDate: string
  acceptType: string
  listPrice: number
  evaluationPrice: number
  orderPrice: number
  applicantUserId: string
  traderCode: string
  donorCode: string
  budgetYear: number
  budgetBranchCode: string
  budgetDepartmentCode: string
  budgetExpenseCode: string
  equipType: string
  workMemo: string
  displayMemo: string
  localMemo: string
  revision: number
}

export function UpdateOrderRequestToJSON(value: UpdateOrderRequest): any {
  return {
    id: value.id ? value.id : undefined,
    status: value.status !== '' ? value.status : undefined,
    cancel_reason: value.cancelReason !== '' ? value.cancelReason : undefined,
    management_flag:
      value.managementFlag !== '' ? value.managementFlag : undefined,
    collection_type:
      value.collectionType !== '' ? value.collectionType : undefined,
    handling_type: value.handlingType !== '' ? value.handlingType : undefined,
    store_type: value.storeType !== '' ? value.storeType : undefined,
    appendix_code: value.appendixCode !== '' ? value.appendixCode : undefined,
    buy_branch_code:
      value.buyBranchCode !== '' ? value.buyBranchCode : undefined,
    department_code:
      value.departmentCode !== '' ? value.departmentCode : undefined,
    shelf_type: value.shelfType !== '' ? value.shelfType : undefined,
    mark: value.mark !== '' ? value.mark : undefined,
    ndc: value.ndc !== '' ? value.ndc : undefined,
    book: value.book !== '' ? value.book : undefined,
    sub: value.sub !== '' ? value.sub : undefined,
    order_date: value.orderDate !== '' ? value.orderDate : undefined,
    temp_accept_date:
      value.tempAcceptDate !== '' ? value.tempAcceptDate : undefined,
    accept_type: value.acceptType !== '' ? value.acceptType : undefined,
    list_price: value.listPrice ? value.listPrice : undefined,
    evaluation_price: value.evaluationPrice ? value.evaluationPrice : undefined,
    order_price: value.orderPrice ? value.orderPrice : undefined,
    applicant_user_id:
      value.applicantUserId !== '' ? value.applicantUserId : undefined,
    trader_code: value.traderCode !== '' ? value.traderCode : undefined,
    donor_code: value.donorCode !== '' ? value.donorCode : undefined,
    budget_year: value.budgetYear ? value.budgetYear : undefined,
    budget_branch_code:
      value.budgetBranchCode !== '' ? value.budgetBranchCode : undefined,
    budget_department_code:
      value.budgetDepartmentCode !== ''
        ? value.budgetDepartmentCode
        : undefined,
    budget_expense_code:
      value.budgetExpenseCode !== '' ? value.budgetExpenseCode : undefined,
    equip_type: value.equipType !== '' ? value.equipType : undefined,
    work_memo: value.workMemo !== '' ? value.workMemo : undefined,
    display_memo: value.displayMemo !== '' ? value.displayMemo : undefined,
    local_memo: value.localMemo !== '' ? value.localMemo : undefined,
    revision: value.revision
  }
}
